import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import baseQuery from "./baseQuery";

export const baseApi = createApi({
  reducerPath: "api",
  baseQuery: baseQuery,
  tagTypes: ['Ticket', 'User', 'Comment', 'ProductTemplate', 'OfferFacets'],
  endpoints: () => ({})
});
